module.exports = __webpack_public_path__ + "static/media/discover.d5e00205.svg";